import React, { FC, useState } from 'react';
import {
  CloseRounded,
  CloudDone,
  Publish,
  SyncLock,
} from '@mui/icons-material';
import { Link, Tooltip } from '@mui/material';
import { FileManaged } from '../../../structures/response/FileManaged';
import styles from './FileRow.module.scss';

interface Props {
  file: FileManaged | File;
  onDelete: (v: FileManaged | File) => Promise<void>;
}

const FileRow: FC<Props> = ({ file, onDelete, ...rest }: Props) => {
  const [processing, setProcessing] = useState(false);
  const handleDelete = async () => {
    setProcessing(true);
    await onDelete(file);
    setProcessing(false);
  };

  const isFile = file instanceof File;

  return (
    <div className={styles.uploadedFileWrapper} {...rest}>
      <div>
        {!processing && (
          <>
            {!isFile && (
              <Tooltip title="Файл загружен на сервер">
                <CloudDone color="info" className={styles.checkIconStyled} />
              </Tooltip>
            )}
            {isFile && (
              <Tooltip title="Файл готов к загрузке">
                <Publish color="warning" className={styles.checkIconStyled} />
              </Tooltip>
            )}
          </>
        )}
        {processing && <SyncLock className={styles.loaderIconStyled} />}
        {!isFile && (
          <Link target="_blank" href={file.viewUrl}>
            {file.name}
          </Link>
        )}
        {isFile && <span>{file.name}</span>}
      </div>
      {!processing && (
        <CloseRounded
          className={styles.closeIconStyled}
          onClick={handleDelete}
        />
      )}
      {processing && (
        <CloseRounded className={styles.closeIconProcessingStyled} />
      )}
    </div>
  );
};

export default FileRow;
